import { render, staticRenderFns } from "./yansheng_yq.vue?vue&type=template&id=2862ded4&scoped=true"
import script from "./yansheng_yq.vue?vue&type=script&lang=js"
export * from "./yansheng_yq.vue?vue&type=script&lang=js"
import style0 from "./yansheng_yq.vue?vue&type=style&index=0&id=2862ded4&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2862ded4",
  null
  
)

export default component.exports